export enum ROUTEPATHS {
  CLIENT = "/client",
  MULTIREV = "/multirev",
  STARS = '/stars'
}
